// ⚡️ Auto-generated from theme: onemall_v1
  export default defineAppConfig({
  "ui": {
    "primary": "primeval",
    "gray": "cool",
    "button": {
      "base": "w-24 uppercase justify-center items-center",
      "font": "font-bold",
      "rounded": "rounded-full",
      "variant": {
        "solid": "bg-gradient-to-r from-primary-600 to-shade-600 disabled:from-primary-400 disabled:to-shade-400 disabled:cursor-not-allowed",
        "outline": "ring-current text-{color}-600 bg-{shade}-300 ring-1",
        "ghost": "bg-yellow-100"
      }
    },
    "slideover": {
      "base": "rounded-tl-2xl rounded-tr-2xl",
      "overlay": {
        "background": "bg-gray-900/75 dark:bg-gray-800/75"
      },
      "height": "h-auto max-h-screen"
    },
    "formGroup": {
      "label": {
        "base": "font-semibold text-base"
      }
    },
    "input": {
      "rounded": "rounded-xs",
      "color": {
        "white": {
          "outline": "focus:ring-1 focus:ring-info-500 focus:bg-info-50 focus:outline"
        }
      }
    },
    "badge": {
      "rounded": "rounded-lg",
      "variant": {
        "solid": "bg-secondary-950",
        "outline": "text-secondary-950 ring-secondary-950"
      }
    },
    "notifications": {
      "position": "top-5 left-1/2 transform -translate-x-1/2 z-[9999] !transform"
    }
  }
});
